import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from '@src/app/services/user-managment/user-profile/user-profile.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile-data',
  templateUrl: './profile-data.component.html',
  styleUrls: ['./profile-data.component.css']
})
export class ProfileDataComponent implements OnInit {

subscription = new Subscription();
  

  constructor(public userProfileService : UserProfileService,public translate:TranslateService) { }

  ngOnInit(): void {
    this.userProfileService.getUserProfile();
    this.subscription.add(this.userProfileService.notify.subscribe({
      next: (data) => {
        if(data === 2) {
          console.log('Notify value:', data);
          Swal.fire({
            icon: 'success',
            title: this.translate.currentLang === 'en' ? 'Updated Successfully' : 'تم التحديث بنجاح'
            });
          } else if(data === 1) {
            Swal.fire({
              icon: 'error',
              title: this.translate.currentLang === 'en' ? "Please recheck your old password" : 'يرجى إعادة التحقق من كلمة المرور القديمة الخاصة بك'
            });
          }
    }
  })
)
}

get firstName() {
  return this.userProfileService.user.firstName;
}

get lastName() {
  return this.userProfileService.user.lastName;
}

get email() {
  return this.userProfileService.user.email;
}

get phoneNumber() {
  return this.userProfileService.user.phoneNumber;
}


}
